/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Recent_ChatsInputs */



/**
* | output |
* | --- |
* | "Your last 3 chats" |
*
* @param {Home_Recent_ChatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_recent_chats = /** @type {((inputs?: Home_Recent_ChatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Recent_ChatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine letzten 3 Chats")
	return /** @type {LocalizedString} */ ("Your last 3 chats")
});